// extracted by mini-css-extract-plugin
export var compactFilters = "_ek-4";
export var detailImage = "_ek-1";
export var dropdownContainer = "_ek-2";
export var imageContainer = "_ek-0";
export var selectedCard = "_ek-3";